export default __webpack_public_path__ + "static/media/personal+training+klub20+west+island+gym.ff154209.jpeg";